import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import { Hours } from "../../../../../../domain/units/Hours";
import GenericNumberFormItemProvider from "../../_generic/number/GenericNumberFormItemProvider";
import { unwrapValue } from "../../../../../../shared/utils/unwrapValue";
import { eqeqeq } from "../../../../../../shared/utils/equality";

const fieldName = "Bad Weather Hours";

const BadWeatherHoursFormItemProvider: FormItemProvider<Hours> = (props: FormItemProviderProps<Hours>) => (
  <GenericNumberFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="BadWeatherHours"
    addonAfter="hours"
    allowNegative={false}
    inputToResult={notEmptyInputToResultWrapper(fieldName, (input: number) => ok(new Hours(input)))}
    outputToInput={unwrapValue}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(BadWeatherHoursFormItemProvider);